var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29457 10.8754L1.82457 7.40539C1.43457 7.01539 0.80457 7.01539 0.41457 7.40539C0.0245703 7.79539 0.0245703 8.42539 0.41457 8.81539L4.59457 12.9954C4.98457 13.3854 5.61457 13.3854 6.00457 12.9954L16.5846 2.41539C16.9746 2.02539 16.9746 1.39539 16.5846 1.00539C16.1946 0.615391 15.5646 0.615391 15.1746 1.00539L5.29457 10.8754Z",
    fill: "#F2F8F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.505164d4bd1baf578bcd930efdc5da70.svg";
export { ForwardRef as ReactComponent };